export function CommonChallenges() {
  const challenges = [
    {
      title: 'Deferred Maintenance Issues',
      problem: 'Years of accumulated maintenance needs including roof repairs, plumbing issues, electrical problems, HVAC replacements, and structural concerns can make properties difficult to sell traditionally.',
      solution: 'We buy properties with deferred maintenance as-is. Our renovation teams handle all repairs after closing, so you don\'t need to invest time or money fixing issues before selling.',
      icon: 'ri-tools-fill'
    },
    {
      title: 'Difficult or Problem Tenants',
      problem: 'Tenants who don\'t pay rent on time, violate lease terms, cause property damage, or create conflicts with neighbors can make properties unattractive to traditional buyers.',
      solution: 'We have extensive experience managing challenging tenant situations. We handle all tenant communications and transitions professionally, relieving you of this burden immediately upon closing.',
      icon: 'ri-user-unfollow-line'
    },
    {
      title: 'Vacancy Problems',
      problem: 'Vacant units generate no income while still incurring costs for utilities, property taxes, insurance, and maintenance. Extended vacancies make financing difficult for traditional buyers.',
      solution: 'Vacant properties are actually ideal for us because they allow immediate renovation work. We make cash offers that don\'t depend on current occupancy or rental income.',
      icon: 'ri-door-open-line'
    },
    {
      title: 'Outdated Systems and Amenities',
      problem: 'Old electrical panels, outdated plumbing, single-pane windows, inefficient heating systems, and lack of modern amenities like in-unit laundry reduce property appeal and value.',
      solution: 'We specialize in updating older properties. Our offers account for necessary upgrades, and we handle all modernization work after purchase.',
      icon: 'ri-time-line'
    },
    {
      title: 'Location Challenges',
      problem: 'Properties in declining neighborhoods, areas with high crime rates, or locations with limited buyer interest can sit on the market for months or years without selling.',
      solution: 'We buy in all locations and neighborhoods. Our investment strategy focuses on long-term value creation, allowing us to purchase properties others avoid.',
      icon: 'ri-map-pin-line'
    },
    {
      title: 'Financial Distress',
      problem: 'Owners facing foreclosure, bankruptcy, divorce, or other financial difficulties need to sell quickly but struggle to find buyers who can close fast enough.',
      solution: 'Our ability to close in 7-14 days with all-cash offers provides the speed you need to resolve financial challenges and move forward with your life.',
      icon: 'ri-alarm-warning-line'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Common Challenges We Solve for Small Apartment Building Owners
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We specialize in purchasing properties that present challenges for traditional sales. Here's how we help:
          </p>
        </div>

        <div className="space-y-8">
          {challenges.map((challenge, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="grid lg:grid-cols-12 gap-6 p-8">
                <div className="lg:col-span-1 flex lg:flex-col items-center lg:items-start">
                  <div className="w-14 h-14 bg-orange-500 rounded-lg flex items-center justify-center">
                    <i className={`${challenge.icon} text-3xl text-white`}></i>
                  </div>
                </div>
                <div className="lg:col-span-11">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{challenge.title}</h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="text-lg font-bold text-red-600 mb-2 flex items-center">
                        <i className="ri-error-warning-line mr-2"></i>
                        The Problem
                      </h4>
                      <p className="text-gray-600">{challenge.problem}</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-green-600 mb-2 flex items-center">
                        <i className="ri-checkbox-circle-line mr-2"></i>
                        Our Solution
                      </h4>
                      <p className="text-gray-600">{challenge.solution}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              No Challenge Too Big
            </h3>
            <p className="text-xl text-gray-600 mb-8">
              Whatever challenges your small apartment building presents, we have the experience, resources, and expertise to handle them. We've successfully purchased hundreds of properties with various issues, and we're ready to help you too.
            </p>
            <a 
              href="#get-offer"
              className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap"
            >
              Tell Us About Your Property
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}